module.exports = __webpack_public_path__ + "03_very_short_brown.c72d0c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/03_very_short_brown.png
// module id = DmsZ
// module chunks = 0